import React, { createContext, useState, useContext, useEffect } from 'react';
import { updateUserTourStatus } from '../../services/userService';

const TourContext = createContext();

export const useTour = () => {
    const context = useContext(TourContext);
    if (!context) {
        throw new Error('useTour must be used within TourProvider');
    }
    return context;
};

export const TourProvider = ({ children }) => {
    const [run, setRun] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const [tourCompleted, setTourCompleted] = useState(false);
    const [isFirstVisit, setIsFirstVisit] = useState(false);
    const [currentTourType, setCurrentTourType] = useState('main');

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user && user._id && !user.hasSeenTour) {
            setIsFirstVisit(true);
            setTimeout(() => {
                setRun(true);
            }, 1000);
        }
    }, []);

    const startTour = () => {
        setCurrentTourType('main');
        setStepIndex(0);
        setRun(true);
    };

    const startPageTour = (pageType) => {
        setCurrentTourType(pageType);
        setStepIndex(0);
        setRun(true);
    };

    const stopTour = () => {
        setRun(false);
    };

    const resetTour = () => {
        setStepIndex(0);
        setRun(false);
        setTourCompleted(false);
    };

    const completeTour = async () => {
        setTourCompleted(true);
        setRun(false);
        
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const userId = user._id || user.userId;
        if (user && userId) {
            try {
                await updateUserTourStatus(userId, true);
                user.hasSeenTour = true;
                localStorage.setItem('user', JSON.stringify(user));
            } catch (error) {
                console.error('Error updating tour status:', error);
            }
        }
    };

    const skipTour = async () => {
        await completeTour();
    };

    const value = {
        run,
        setRun,
        stepIndex,
        setStepIndex,
        tourCompleted,
        isFirstVisit,
        currentTourType,
        startTour,
        startPageTour,
        stopTour,
        resetTour,
        completeTour,
        skipTour
    };

    return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
};